var exports = {
  "i": "LiveBadge.module__liveBadge___U2pOdU",
  "f": "LiveBadge.module__liveBadgeOnVoiceTile___U2pOdU",
};

module.exports = exports;
